import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase-client';
import ErrorMessage from './formComponents/ErrorMessage';

// Relationship role options
const ROLE_OPTIONS = [{
  value: 'parent',
  label: 'Parent'
}, {
  value: 'child',
  label: 'Child'
}];
export default function AddOrInviteFamilyMemberForm({
  family,
  onAdded,
  onCancel
}) {
  const sendFamilyInviteFn = httpsCallable(functions, 'sendFamilyInvite');
  const [username, setUsername] = useState('');
  const [role, setRole] = useState('child');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState('');
  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setInfo('');
    setLoading(true);
    try {
      const normalizedUsername = username.trim().toLowerCase();
      await sendFamilyInviteFn({
        familyId: family.id,
        username: normalizedUsername,
        role,
      });
      setInfo(`Invitation sent to ${normalizedUsername}.`);
      onAdded();
    } catch (err) {
      setError(err.message || 'Failed to send invitation.');
    } finally {
      setLoading(false);
    }
  };
  return <form onSubmit={handleSubmit} className="flex-column" style={{
    gap: '1rem',
    maxWidth: 400
  }}>
      <label>
        Username
        <input type="text" className="form-input" value={username} onChange={e => setUsername(e.target.value)} required />
      </label>

      <label className="form-label">
        Role
        <div className="custom-select-wrapper">
          <select className="custom-select" value={role} onChange={e => setRole(e.target.value)}>
            {ROLE_OPTIONS.map(({
            value,
            label
          }) => <option key={value} value={value}>
                {label}
              </option>)}
          </select>
          <svg className="custom-select-arrow" width="12" height="8" viewBox="0 0 12 8" aria-hidden>
            <path d="M1 1l5 5 5-5" fill="none" stroke="currentColor" strokeWidth="2" />
          </svg>
        </div>
      </label>

      <div style={{
      display: 'flex',
      gap: '0.5rem',
      marginTop: '1rem'
    }}>
        <button className="button" type="submit" disabled={loading}>
          {loading ? 'Processing...' : 'Send Invite'}
        </button>
        <button className="button button-secondary" type="button" onClick={onCancel} disabled={loading}>
          Cancel
        </button>
      </div>

      {error && <ErrorMessage message={error} />}
      {info && <p style={{
      color: 'green'
    }}>{info}</p>}
    </form>;
}
